import { useEffect } from 'react';
import useConstantRefCallback from './useConstantRefCallback';

// Note that this hook assumes that element/type don't change, which is ok as
// that is not our common use case
export function useElementBinding(element, type, fn, deps = []) {
  // we need to wrap fn because if the fn reference passed in changes,
  // removing the event listener won't work properly
  const callback = useConstantRefCallback((...params) => fn(...params));

  // wrap add/remove event listener calls so that useEffect below does not
  // depend on element/type/callback
  const addEventListener = useConstantRefCallback(() =>
    element.addEventListener(type, callback),
  );
  const removeEventListener = useConstantRefCallback(() =>
    element.removeEventListener(type, callback),
  );

  useEffect(() => {
    addEventListener();
    return removeEventListener;
    // It's on the consumer to provide appropriate dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export function useDocumentBinding(type, fn, deps = []) {
  useElementBinding(document, type, fn, deps);
}

export function useWindowBinding(type, fn, deps = []) {
  useElementBinding(window, type, fn, deps);
}
